var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0V2.66667H3.66667C2.19391 2.66667 1 3.86057 1 5.33333V18.6667C1 20.1394 2.19391 21.3333 3.66667 21.3333H19.6667C21.1394 21.3333 22.3333 20.1394 22.3333 18.6667V5.33333C22.3333 3.86057 21.1394 2.66667 19.6667 2.66667H19V0H17V2.66667H7V0H5ZM3.66667 4.66667H19.6667C20.0349 4.66667 20.3333 4.96514 20.3333 5.33333V6.66732L3 6.66732V5.33333C3 4.96514 3.29848 4.66667 3.66667 4.66667ZM3 8.66732L20.3333 8.66732V18.6667C20.3333 19.0349 20.0349 19.3333 19.6667 19.3333H3.66667C3.29848 19.3333 3 19.0349 3 18.6667V8.66732Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7ba1ceef71996054a154fd3b98b58e5c.svg";
export { ForwardRef as ReactComponent };